import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import WebhookForm from '../../components/Webhooks/WebhookForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['webhook']}`;

const WebhooksDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const [webhook, setWebhook] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [deleteError, setDeleteError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [useInAutomation, setUseInAutomation] = useState(false);

  const { accountId, domainId, webhookId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/webhooks/${webhookId}`)
      .then(({ webhook }) => {
        if (!webhook) {
          navigate(`/accounts/${accountId}/domains/${domainId}/webhooks`);
        }

        setWebhook(webhook);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, webhookId]);

  const update = (webhook) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/webhooks/${webhookId}`, {
      method: 'PUT',
      body: JSON.stringify(webhook),
    })
      .then((redirect) => {
        setGuidanceShow(false);
        redirect && navigate(`/accounts/${accountId}/domains/${domainId}/webhooks`);
      })
      .catch(setUserError);
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/webhooks/${webhook.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/webhooks/${webhook.id}/details`, '/webhooks'));
      })
      .catch(setDeleteError);
  };

  const showUserFlow = () => {
    setGuidanceShow(true);
    setUseInAutomation(true);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!webhook) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/webhooks` },
    { title: webhook.name, href: `#${location.pathname.replace('/details', '/analytics')}` },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${webhook.name} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Webhook"
        redirect={`/accounts/${accountId}/domains/${domainId}/webhooks`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={webhook}
        setShow={() => {
          setGuidanceShow(false);
          setUseInAutomation(false);
        }}
        useInAutomation={useInAutomation}
      />
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <WebhookForm
              webhook={webhook}
              saveWebhook={(webhook) => {
                update(webhook);
              }}
              deleteWebhook={(cb) => del(cb)}
              showUserFlow={() => showUserFlow(true)}
              deleteError={deleteError?.message}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default WebhooksDetailsPage;
